import React from "react";
import { useTranslation } from "react-i18next";

export default function SectorContentBox({pagecontent}) {
  const { t } = useTranslation();
  return (
    <div className="flex w-full justify-center items-center py-8  px-4">
      <div className="flex flex-col w-full max-w-7xl gap-6">
        {/* Header Section */}
      {pagecontent.contentheading &&
        <div className="w-full">
          <h1 className="text-4xl font-semibold w-full md:w-1/2 mb-4 md:mb-8">
            {t(`${pagecontent.contentheading}`)}
          </h1>
        </div>
      }
        
        {/* Content Section */}
        <div className="flex flex-col gap-8 md:gap-10 w-full pb-8">
          {/* Left Column */}
          <div className="flex flex-col md:flex-row gap-8">
            <div className="md:w-1/2">
              <div className="w-full text-gray-700 leading-relaxed">
                {t(pagecontent.contentleft)}
              </div>
            </div>

            {/* Right Column */}
            <div className="md:w-1/2"> 
              <div className="w-full text-gray-700 leading-relaxed">
                {t(`${pagecontent.contentright}`)}
              </div>
            </div>
          </div>

          <div className="flex flex-row">
            <div className="md:w-1/2">
            {pagecontent.extracontentleft && 
                  <div className="w-full text-gray-700 leading-relaxed">
                  {t(`${pagecontent.extracontentleft}`)}
                  </div>
                }
            </div>
            <div className="md:w-1/2">
              {pagecontent.extracontentright &&
                <div className="w-full text-gray-700 leading-relaxed">
                {t(`${pagecontent.extracontentright}`)}
                </div>
              }
            </div>
          </div>
        </div>
        
        {pagecontent.webaddress &&
          <div className="flex flex-col flex-start pb-8">
            <p className="">Web addresses</p>
            <p className="underline">
              <a 
                href={`https://${t(pagecontent.webaddress).replace(/^https?:\/\//, '')}`} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                {t(pagecontent.webaddress)}
              </a>
            </p>
          </div>
        }

        <div>
          <img className="h-64 sm:h-80 md:h-[35rem] w-full object-cover rounded-lg grayscale hover:grayscale-0" src={pagecontent.image ? pagecontent.image :'assets/sector-content-box-image.webp'}  alt="" />
        </div>
      </div>
    </div>
  );
}
